import { useMutation } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { searchFeedbackContextAtom } from './state';

import {
  type AnswerSource,
  searchClickFeedbackMutation,
} from '@/_generated/api-clients/xp';

/** Fires search-click-feedback when a user clicks an AI search source. */
export const useSearchClickFeedback = () => {
  const feedbackContext = useAtomValue(searchFeedbackContextAtom);
  const { mutate } = useMutation(searchClickFeedbackMutation());

  return (source: AnswerSource) => {
    if (!feedbackContext?.queryId) return;

    mutate({
      query: {
        queryId: feedbackContext.queryId,
        resultId: source.id,
        'smart.provider': feedbackContext.provider,
      },
    });
  };
};
